<template>
    <div
        style="height: 100%; overflow: hidden; font-family: Arial, Helvetica, sans-serif"
        :style="{
            '--iframe-background-color': setting.BackgroundColor!,
            '--iframe-text-color': setting.ForegroundColor!,
            '--iframe-font-size': setting.FontSize! + '%',
        }"
    >
        <div
            style="
                gap: 1em;
                display: flex;
                height: 100%;
                background-color: var(--iframe-background-color) !important;
                color: var(--iframe-text-color) !important;
                font-size: var(--iframe-font-size) !important;
            "
        >
            <div
                v-for="(table, i) in setting.Tables"
                :key="i"
                :style="{
                    flex: `1 1 ${100 / (setting.Tables?.length == 0 ? 1 : setting.Tables?.length)}%`,
                    width: `${100 / (setting.Tables?.length == 0 ? 1 : setting.Tables?.length)}%`,
                }"
            >
                <ProductionTable
                    :table="table"
                    :setting="setting"
                    :preview="preview"
                />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { ProductionDeviceSetting } from '@/objects/generated';
import ProductionTable from './ProductionTable.vue';
import { onMounted, watch } from 'vue';

const props = defineProps<{
    /**
     * The setting to display.
     */
    setting: ProductionDeviceSetting;

    /**
     * If true, the component is used in a preview. and will use preview data
     * instead of real data.
     */
    preview?: boolean;
}>();

const setDimensionProperties = () => {
    let headerelement = document.querySelector('h2.header') as HTMLElement;
    let tableelement = document.querySelector('.production-table') as HTMLElement;

    if (!tableelement || !headerelement) {
        console.warn('Could not find table or header element to calculate max number of rows');
        return;
    }

    let headerHeigh = headerelement.getBoundingClientRect().height ?? 0;
    let rowHeight = tableelement.querySelector('thead > tr')?.getBoundingClientRect().height ?? 0;
    let maxNumberOfRows = Math.floor((window.innerHeight - headerHeigh - rowHeight) / rowHeight);

    props.setting.DisplayHeight = window.innerHeight;
    props.setting.DisplayWidth = window.innerWidth;
    props.setting.NumberOfLinesCalculated = maxNumberOfRows;
    props.setting.DisplayRowHeight = rowHeight;
};

onMounted(() => {
    if (!props.preview) {
        setDimensionProperties();

        setInterval(() => {
            setDimensionProperties();
        }, 1000);
    }
});
</script>
